// removed by extract-text-webpack-plugin
module.exports = {"navigation":"Header__navigation___1Wggx","navigation__brand":"Header__navigation__brand___22c21","navigation__right":"Header__navigation__right___1eXpq","navigation__logo":"Header__navigation__logo___1RPOO","navigation__link":"Header__navigation__link___Itx1V","navigation__link--active":"Header__navigation__link--active___Q2A9C","dropdown":"Header__dropdown___2Gjrz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.scss
// module id = 1228
// module chunks = 1